module.exports = __webpack_public_path__ + "static/media/notes-icon.c88e90e2.svg";